import React, { Component } from 'react';


export class Loader extends Component {
    static displayName = Loader.name;

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidMount() {

    }


    render() {

        let loader = null;
        if (this.props.loading) {

            loader = <div className={`position-fixed d-flex justify-content-center align-items-center loader--div ${this.props.fullscreen == null || this.props.fullscreen == false ? "" : ""}`}>
                <div className="loader">
                    <div></div><div></div><div></div><div></div>
                </div>
                </div>;

        }

        return (<>{loader}</>);




    }
}
